import { DialogSaurus } from '../dialog-saurus/dialog-saurus';
import { useCallback } from 'react';
import { useThemeQueries } from 'views/theme';
import { CadastroResposta } from './components/cadastro-resposta/cadastro-resposta';
import { useCadastros } from 'services/app';

interface DialogRespostaPropagandaProps {
    openned: boolean;
    propagandaId: string;
    revendaNome: string;
}

export const DialogRespostaPropaganda = ({ openned, propagandaId, revendaNome }: DialogRespostaPropagandaProps) => {
    const { isMobile } = useThemeQueries();
    const { fecharCadastroPropagandaResposta } = useCadastros();

    const fecharDialog = useCallback(() => {
        fecharCadastroPropagandaResposta()
    }, [fecharCadastroPropagandaResposta])

    return (
        <DialogSaurus
            aberto={openned}
            titulo={'Adicionar Resposta'}
            tamanho="lg"
            fullScreen={isMobile}
            isButtonTitleClose
            handleClickClose={fecharDialog}

        >
            <CadastroResposta
                propagandaId={propagandaId}
                revendaNome={revendaNome}
            />
        </DialogSaurus>
    );
}